// FILE: src/data/pricingPlans.js

import { Zap, Star, Users } from "lucide-react";

const pricingPlans = [
    {
        name: "Starter",
        price: "Free",
        period: "",
        description: "Covers one full term of teaching tools",
        features: [
            "Record and track student assessments",
            "Create personalized units and DOK skills with AI (up to 8 subjects and 32 units)",
            "Generate subject comments for up to 30 students across 8 subjects",
            "Generate unit plans for up to 2 topics",
            "Generate lesson plans, worksheets, rubrics, and activities (up to 10 each)",
            "Convert Youtube videos into concise, student-friendly study notes (up to 5 videos)"
        ],
        icon: Zap,
        highlight: false,
        cta: "Start Free Trial"
    },
    {
        name: "Monthly",
        price: "$7",
        period: "Billed Monthly",
        description: "Ideal for active teachers and small departments",
        features: [
            "Record and track student assessments without restrictions",
            "Create unlimited personalized units and DOK skills with AI",
            "Generate subject comments for all students across all subjects",
            "Generate unlimited unit plans for any topics",
            "Generate unlimited lesson plans, worksheets, rubrics, and activities",
            "Convert unlimited Youtube videos into concise, student-friendly study notes"
        ],
        icon: Star,
        highlight: false,
        cta: "Start Free Trial"
    },
    {
        name: "Annual",
        price: "$50",
        period: "Billed Annually",
        description: "Ideal for active teachers and small departments looking to save 40%",
        features: [
            "Huge Discount 40%!",
            "Record and track student assessments without restrictions",
            "Create unlimited personalized units and DOK skills with AI",
            "Generate subject comments for all students across all subjects",
            "Generate unlimited unit plans for any topics",
            "Generate unlimited lesson plans, worksheets, rubrics, and activities",
            "Convert unlimited Youtube videos into concise, student-friendly study notes"
        ],
        icon: Users,
        highlight: true,
        cta: "Start Free Trial"
    }
];

export default pricingPlans;
